// import { Box, Button, Checkbox, Link } from "@mui/material";
import { useState } from "react";
// import ErrorHelper from "../../../../../components/ErrorWrapper";
// import Flex from "../../../../../components/Flex";
// import LoadingOverlay from "../../../../../components/LoadingOverlay";
// import StyledDialog from "../../../../../components/StyledDialog";
import { useSignatureController } from "../../../../../components/signiture/use-signature-controller";
// import { useCreateDocument } from "../../../../../hooks/use-create-document";
import useDisclosure from "../../../../../hooks/use-disclosure";
import MedicalServicesAgreementForm from "./MedicalServicesAgreementForm";

export const MedicalServicesAgreementButton = ({
  setFieldValue,
  values,
  viewOnly,
  errors,
}: {
  isPreviewVisible?: boolean;
  setFieldValue: (field: string, value: any) => void;
  values: any;
  viewOnly?: boolean;
  errors: any;
}) => {
  const disclosureHost = useDisclosure();
  const [_k, setK] = useState<boolean>(true);
  const { canvasRef, signPad, isSignEmpty } = useSignatureController(
    disclosureHost.opened,
    values?.medicalServicesAgreementSign
  );
  // const [isLoading, setIsLoading] = useState(false);
  // const { createDocumentWithHtml, eleRef } = useCreateDocument(setIsLoading);

  // const renderContent = () => {
  //   return (
  //     <Box width={"40vw"} overflow={"hidden"}>
  //       <Box ref={eleRef}>
  //         <MedicalServicesAgreementForm
  //           viewOnly={viewOnly}
  //           setFieldValue={setFieldValue}
  //           values={values}
  //           canvasRef={canvasRef}
  //           signPad={signPad}
  //           setK={setK}
  //           isSignEmpty={isSignEmpty}
  //           errors={errors}
  //         />
  //       </Box>
  //     </Box>
  //   );
  // };

  return (
    <>
      {/* <LoadingOverlay isLoading={isLoading} /> */}
      {/* {!isPreviewVisible && (
        <ErrorHelper error={errors.medicalServicesAgreement}>
          <Flex gap={1} alignItems={"center"}>
            <Checkbox
              disabled={viewOnly}
              checked={values.medicalServicesAgreement}
              onChange={(_, checked) =>
                setFieldValue("medicalServicesAgreement", checked)
              }
            />
            <span>
              I agree to the <b>Medical Services Agreement</b> &nbsp;
              <Link href="#" onClick={() => disclosureHost.open()}>
                terms & conditions
              </Link>
              .
            </span>
          </Flex>
        </ErrorHelper>
      )} */}

      {/* {!isPreviewVisible ? (
        <StyledDialog
          open={disclosureHost.opened}
          onClose={disclosureHost.close}
          dialogTitle="Medical Services Agreement"
          dialogAction={
            !viewOnly ? (
              <Button
                variant="contained"
                onClick={() => {
                  setFieldValue(
                    "medicalServicesAgreementSign",
                    isSignEmpty() ? undefined : signPad?.toDataURL()
                  );

                  createDocumentWithHtml("Medical_Services_Agreement.pdf").then(
                    () => {
                      disclosureHost.close();
                    }
                  );
                }}
              >
                Submit
              </Button>
            ) : (
              ""
            )
          }
        >
          {renderContent()}
        </StyledDialog>
      ) : (
        renderContent()
      )} */}
      <MedicalServicesAgreementForm
        viewOnly={viewOnly}
        setFieldValue={setFieldValue}
        values={values}
        canvasRef={canvasRef}
        signPad={signPad}
        setK={setK}
        isSignEmpty={isSignEmpty}
        errors={errors}
      />
    </>
  );
};
